import { useForm } from "@refinedev/react-hook-form";
import { Port } from "../../../types/port";
import { HttpError, useParsed } from "@refinedev/core";

export const useStoreForm = () => {
  let { id } = useParsed();

  const form = useForm<Port, HttpError, Port>({
    refineCoreProps: {
      action: "edit",
      resource: "AdminPorts",
      id
    },
  });

  const port = form.refineCore.query?.data?.data;

  const defaultValues: Partial<Port> = {
    name: port?.name ?? "",
    code: port?.code ?? "",
    countryCode: port?.countryCode ?? "",
    isDeleted: port?.isDeleted ?? false,
  };

  return {
    ...form,
    resetForm: () => {
      form.reset(defaultValues);
    },
  };
}